module.exports = __webpack_public_path__ + "img/image006.730cf980.png";